<template src="./RegisterParceiros.html"></template>
<script>
import mixins from "../../../../../Mixins.js";
export default {
  mixins: [mixins],
  data() {
    return {
      showContent: false,
      parceiros: undefined,
      windowWidth: 0,
      currentx: 1,
      numPages: 0,
      pagination: false,
      searchParceiros: "",
      popupParceiro: false,
      popupParceiroData: {
        active: undefined,
        codTuss: undefined,
        codParceiro: undefined,
        id: undefined,
        name: undefined,
      },
      invalidFields: {
        name: false
      },
      toggleActiveId : null
    }
  },
  mounted() {
    const vm = this;
    vm.init();
  },
  created() {
    const vm = this;
    window.addEventListener("resize", vm.handleResize);
    vm.handleResize();
  },
  destroyed() {
    const vm = this;
    window.removeEventListener("resize", vm.handleResize);
  },
  watch: {
    currentx: function () {
      const vm = this;
      vm.changePagination();
    },
  },
  methods: {
    init() {
      const vm = this;
      vm.getParceiros();
    },

    getParceiros() {
      const vm = this;
      const page = vm.currentx - 1;
      vm.axios
        .get(
          vm.$store.state.filooServer +
          "marketplace/parceiros?page=" + page + "&search=" + vm.searchParceiros + "&size=10&sort=id,asc", {
            headers: {
              Authorization: vm.$session.get("bearerDefault")
            },
          }
        )
        .then(function (response) {
          if (response.status == 200) {
            vm.parceiros = response.data.content;
            vm.numPages = response.data.totalPages;
            vm.pagination = vm.numPages > 1;
            vm.showContent = true;
          }
        });
    },
    changePagination() {
      const vm = this;
      vm.getParceiros();
    },
    confirmeChangeStatus(id) {
      const vm = this;
      vm.toggleActiveId = id;
      vm.$bvModal.show("modal-change-status-partner");
    },
    toggleActive() {
      const vm = this;
      vm.axios
      .put(
        vm.$store.state.filooServer + "marketplace/parceiro/toggle/" + vm.toggleActiveId, {}, {
          headers: {
          Authorization: vm.$session.get("bearerDefault")
          },
        }
      )
      .then(function (response) {
        if (response.status == 200) {
          vm.$bvModal.hide("modal-change-status-partner");
          vm.showNotifySuccess("Operação realizada","O status do parceiro foi alterado com sucesso", 3000);
          vm.getParceiros();
        }
      }).catch(function () {
        vm.$bvModal.hide("modal-change-status-partner");
        vm.showNotifyError("Não foi possível alterar o status do parceiro", 6000);
      })
      .finally(function() {
        vm.$bvModal.hide("modal-change-status-partner");
      });
    },
    addNewParceiroPopup() {
      const vm = this;
      vm.popupParceiro = true;
      vm.popupParceiroData = {
        active: true,
        codTuss: undefined,
        codParceiro: undefined,
        id: undefined,
        name: undefined,
      }
    },

    editParceirosPopup(parceiros) {
      const vm = this;
      vm.popupParceiro = true;
      vm.popupParceiroData = {
        active: parceiros.active,
        phone: parceiros.phone,
        id: parceiros.id,
        name: parceiros.name,
      }
    },

    addNewParceiro() {
      const vm = this;

      vm.invalidFields.name = vm.testNullUndefinedEmpty(vm.popupParceiroData.name);

      if (!vm.invalidFields.name) {
        vm.axios
        .post(
          vm.$store.state.filooServer + "marketplace/parceiros", vm.popupParceiroData, {
            headers: {
              Authorization: vm.$session.get("bearerDefault")
            },
          }
        )
        .then(function (response) {
          if (response.status == 200) {
            vm.popupParceiro = false;
            vm.$swal({
                title: "Parceiro Salvo!",
                icon: "success",
              });
            vm.getParceiros();
          }
        })
        .catch(function () {
          vm.$vs.notify({
              title: "Ocorreu um erro",
              text: "Parceiro não salvo",
              color: "danger",
              icon: "error",
              time: 6000
            });
        });
      }
    },

    editParceiro() {
      const vm = this;
      vm.invalidFields.name = vm.testNullUndefinedEmpty(vm.popupParceiroData.name);

      if(!vm.invalidFields.name) {
        vm.axios
        .put(
          vm.$store.state.filooServer + "marketplace/parceiros/" , vm.popupParceiroData, {
            headers: {
              Authorization: vm.$session.get("bearerDefault")
            },
          }
        )
        .then(function (response) {
          if (response.status == 200) {
            vm.popupParceiro = false;
            vm.$swal({
                title: "Parceiro Salvo!",
                icon: "success",
              });
            vm.getParceiros();
          }
        }).catch( function() {
          vm.$vs.notify({
              title: "Ocorreu um erro",
              text: "Parceiro não salvo",
              color: "danger",
              icon: "error",
              time: 6000
            });
        });
      }
    },

    changeSearchParceiros() {
      const vm = this;
      vm.currentx = 1;
      vm.getParceiros();
    },

    handleResize() {
      const vm = this;
      vm.windowWidth = window.innerWidth;
    },
  }
};
</script>

<style lang="scss" src="./RegisterParceiros.scss">
</style>